/* Niclas + ChatGPT | 2026-10-17 | Optional draft UX. Shopify owns final pricing. */
(() => {
  if (customElements.get('avolt-atelier-trio')) return;
  let pending = false;
  async function addItems(host, items, button) {
    if (host.busy || pending) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.classList.contains('is-cart-loading')) return;
    const error = host.querySelector('.avolt-atelier-error');
    host.busy = true;
    pending = true;
    drawer?.setLoadingStatus?.(true);
    drawer?.emit?.('start-update', {});
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    let added = false;
    try {
      const payload = { items, sections_url: window.location.pathname };
      if (drawer?.dataset.sectionId) payload.sections = [drawer.dataset.sectionId];
      const response = await fetch(host.dataset.url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok || data.status || data.errors) {
        throw new Error(typeof data.description === 'string' ? data.description : host.dataset.error);
      }
      added = true;
      const first = data.items?.[0];
      let html = data.sections?.[drawer?.dataset.sectionId];
      if (drawer && !html) {
        const refresh = new URL(window.location.href);
        refresh.searchParams.set('section_id', drawer.dataset.sectionId);
        const sectionResponse = await fetch(refresh);
        if (!sectionResponse.ok) throw new Error(host.dataset.error);
        html = await sectionResponse.text();
      }
      if (drawer && first && html && typeof drawer.purchaseHandler === 'function') {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (!parsed.querySelector('[data-sidebar-template="CartDrawer"]')) throw new Error(host.dataset.error);
        drawer.updateAsideProductsByParsedState?.(first);
        await drawer.purchaseHandler(parsed, first);
      } else {
        window.location.assign(host.dataset.cartUrl || window.routes?.cart_url || '/cart');
      }
    } catch (failure) {
      if (added) {
        window.location.assign(host.dataset.cartUrl || window.routes?.cart_url || '/cart');
      } else {
        error.textContent = failure.message || host.dataset.error;
        error.hidden = false;
      }
    } finally {
      host.busy = false;
      pending = false;
      drawer?.setLoadingStatus?.(false);
      drawer?.emit?.('stop-update', {});
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
  customElements.define('avolt-atelier-add', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('change', event => event.stopPropagation());
      this.querySelector('[data-atelier-add]').addEventListener('click', event => {
        const id = Number(this.querySelector('[data-atelier-variant]').value);
        if (Number.isSafeInteger(id) && id > 0) addItems(this, [{ id, quantity: 1 }], event.currentTarget);
      });
    }
  });
  customElements.define('avolt-atelier-info', class extends HTMLElement {
    connectedCallback() {
      if (this.bound || !window.HTMLDialogElement?.prototype.showModal) return;
      const details = this.querySelector('details');
      const trigger = details?.querySelector('summary');
      const content = details?.querySelector('.avolt-atelier-info__content');
      if (!trigger || !content) return;
      this.bound = true;
      const dialog = document.createElement('dialog');
      dialog.className = 'avolt-atelier-info__dialog';
      dialog.setAttribute('aria-label', trigger.getAttribute('aria-label'));
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'avolt-atelier-info__close';
      close.textContent = '×';
      close.setAttribute('aria-label', this.dataset.closeLabel);
      close.addEventListener('click', () => dialog.close());
      dialog.append(close, content);
      this.append(dialog);
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', event => {
        event.preventDefault();
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        this.dispatchEvent(new Event('toggle', { bubbles: true }));
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({ preventScroll: true });
        this.dispatchEvent(new Event('toggle', { bubbles: true }));
      });
    }
  });
  function makePicker(host, select) {
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const chosen = select.value;
    const options = [...select.options].sort((a, b) => Number(a.dataset.rank) - Number(b.dataset.rank));
    select.append(...options);
    select.value = chosen;
    const control = select.closest('.avolt-atelier-slot__control');
    const trigger = element('button', 'avolt-atelier-picker-trigger');
    trigger.type = 'button';
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    const selected = element('span', 'avolt-atelier-picker-trigger__selection');
    selected.id = select.id + '-selected';
    const change = element('span', 'avolt-atelier-picker-trigger__change', host.dataset.pickerChange);
    change.id = select.id + '-change';
    trigger.setAttribute('aria-labelledby', change.id + ' ' + select.id + '-label ' + selected.id);
    const selectedName = element('span', 'avolt-atelier-picker-trigger__name');
    const selectedDetails = element('span', 'avolt-atelier-picker-trigger__details');
    selected.append(selectedName, selectedDetails);
    trigger.append(select.closest('.avolt-atelier-slot').querySelector('[data-atelier-image]'), selected, change);
    const dialog = element('dialog', 'avolt-atelier-picker');
    dialog.id = select.id + '-dialog';
    trigger.setAttribute('aria-controls', dialog.id);
    const header = element('div', 'avolt-atelier-picker__header');
    const title = element('h3', 'avolt-atelier-picker__title', host.dataset.pickerTitle + ' · ' + control.querySelector('label').textContent.trim());
    title.id = select.id + '-title';
    dialog.setAttribute('aria-labelledby', title.id);
    const close = element('button', 'avolt-atelier-picker__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', host.dataset.pickerClose);
    header.append(title, close);
    const list = element('div', 'avolt-atelier-picker__list');
    const groups = new Map();
    const rows = [];
    const number = new Intl.NumberFormat(host.dataset.locale);
    options.forEach(option => {
      const rank = option.dataset.rank;
      const groupKey = rank === '4' ? rank + option.dataset.model : rank;
      if (!groups.has(groupKey)) {
        const group = element('section', 'avolt-atelier-picker__group');
        const headingText = rank === '1' ? 'Square 1 · ' + number.format(1.8) + ' m' : rank === '2' ? 'Square 2' : rank === '3' ? 'Square 1 · ' + number.format(3) + ' m' : rank === '5' ? 'USB-C → USB-C' : rank === '6' ? 'USB-C → Lightning' : option.dataset.model;
        const heading = element('h4', 'avolt-atelier-picker__group-title', headingText);
        heading.id = select.id + '-group-' + groups.size;
        group.setAttribute('aria-labelledby', heading.id);
        group.append(heading);
        groups.set(groupKey, group);
        list.append(group);
      }
      const row = element('button', 'avolt-atelier-picker__option');
      row.type = 'button';
      row.dataset.variantId = option.value;
      const image = element('img');
      image.src = option.dataset.image;
      image.alt = '';
      image.width = 64;
      image.height = 64;
      image.loading = 'lazy';
      const copy = element('span', 'avolt-atelier-picker__copy');
      copy.append(element('span', 'avolt-atelier-picker__colour', option.dataset.colour), element('span', 'avolt-atelier-picker__specs', option.dataset.model + ' · ' + option.dataset.specs));
      const price = element('span', 'avolt-atelier-picker__price', option.dataset.priceLabel);
      const tick = element('span', 'avolt-atelier-picker__tick', '✓');
      tick.setAttribute('aria-hidden', 'true');
      row.append(image, copy, price, tick);
      row.addEventListener('click', () => {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        dialog.close();
      });
      rows.push(row);
      groups.get(groupKey).append(row);
    });
    dialog.append(header, list);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    list.addEventListener('keydown', event => {
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      const index = rows.indexOf(document.activeElement);
      if (index < 0) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? rows.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : rows.length - 1)) % rows.length;
      rows[next].focus();
    });
    dialog.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({ preventScroll: true });
    });
    trigger.addEventListener('click', () => {
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      const active = rows.find(row => row.dataset.variantId === select.value);
      active?.focus({ preventScroll: true });
      active?.scrollIntoView({ block: 'nearest' });
    });
    select.atelierPicker = {
      sync() {
        const option = select.selectedOptions[0];
        selectedName.textContent = option.dataset.model + ' · ' + option.dataset.colour;
        selectedDetails.textContent = option.dataset.specs + ' · ' + option.dataset.priceLabel;
        rows.forEach(row => row.setAttribute('aria-pressed', String(row.dataset.variantId === select.value)));
      }
    };
    control.classList.add('avolt-atelier-slot__control--enhanced');
    control.append(trigger, dialog);
    select.hidden = true;
  }
  customElements.define('avolt-atelier-trio', class extends HTMLElement {
    connectedCallback() {
      this.bindStickyGuard();
      if (this.bound) return;
      this.bound = true;
      this.querySelectorAll('[data-atelier-choice]').forEach(select => {
        select.addEventListener('change', () => this.updatePrice());
        makePicker(this, select);
      });
      this.querySelector('[data-atelier-submit]').addEventListener('click', event => {
        const quantities = new Map();
        for (const select of this.querySelectorAll('[data-atelier-choice]')) {
          const id = Number(select.value);
          if (!Number.isSafeInteger(id) || id <= 0) return;
          quantities.set(id, (quantities.get(id) || 0) + 1);
        }
        const items = [...quantities].map(([id, quantity]) => ({ id, quantity }));
        addItems(this, items, event.currentTarget);
      });
      this.updatePrice();
    }
    disconnectedCallback() {
      this.stickyAbort?.abort();
      this.stickyResize?.disconnect();
      if (this.stickyFrame != null) cancelAnimationFrame(this.stickyFrame);
      this.stickyFrame = null;
      this.stickyRoot?.removeAttribute('data-avolt-set-before-scroll');
    }
    bindStickyGuard() {
      this.stickyAbort?.abort();
      this.stickyResize?.disconnect();
      if (this.stickyFrame != null) cancelAnimationFrame(this.stickyFrame);
      this.stickyFrame = null;
      const root = this.closest('product-info');
      if (!root) return;
      this.stickyRoot = root;
      const update = () => {
        this.stickyFrame = null;
        const builder = this.querySelector('[data-atelier-builder]');
        const expanded = builder ? builder.open : Boolean(this.querySelector('[data-atelier-visual]'));
        const beforeEnd = this.getBoundingClientRect().bottom > 0;
        const pickerOpen = Boolean(this.querySelector('dialog[open]'));
        root.toggleAttribute('data-avolt-set-before-scroll', Boolean(expanded && (beforeEnd || pickerOpen)));
      };
      const schedule = () => {
        if (this.stickyFrame == null) this.stickyFrame = requestAnimationFrame(update);
      };
      this.stickyAbort = new AbortController();
      const signal = this.stickyAbort.signal;
      window.addEventListener('scroll', schedule, { capture: true, passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      this.addEventListener('toggle', schedule, { capture: true, signal });
      if (window.ResizeObserver) {
        this.stickyResize = new ResizeObserver(schedule);
        this.stickyResize.observe(this);
      }
      update();
    }
    formatPrice(cents) {
      // Liquid's money filter supplies the active market's prefix, suffix and separators.
      // A fixed sample avoids assuming that language determines currency formatting.
      const sample = this.dataset.moneyExample || '';
      const match = sample.match(/^(.*?)([0-9][0-9.,'’\s]*[0-9])(.*?)$/);
      if (!match) return (cents / 100).toFixed(2);
      const fraction = match[2].match(/([.,])89$/);
      const integerSample = fraction ? match[2].slice(0, -3) : match[2];
      const group = integerSample.match(/[^0-9]/)?.[0] || '';
      const parts = (cents / 100).toFixed(fraction ? 2 : 0).split('.');
      const integer = group ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group) : parts[0];
      return match[1] + integer + (fraction ? fraction[1] + parts[1] : '') + match[3];
    }
    updatePrice() {
      let original = 0;
      const prices = [];
      let slotIndex = 0;
      const previews = this.querySelectorAll('[data-atelier-preview]');
      for (const select of this.querySelectorAll('[data-atelier-choice]')) {
        const option = select.selectedOptions[0];
        if (!option) continue;
        original += Number(option.dataset.price);
        prices.push(Number(option.dataset.price));
        const image = select.closest('.avolt-atelier-slot').querySelector('[data-atelier-image]');
        image.src = option.dataset.image;
        image.alt = option.dataset.alt;
        const preview = previews[slotIndex++];
        if (preview) preview.src = option.dataset.image;
        select.atelierPicker?.sync();
      }
      let discounted = Math.round(original * (100 - Number(this.dataset.percent)) / 100);
      if (this.dataset.offerType === 'buy_x_get_y') {
        const paid = Number(this.dataset.buyQuantity);
        const free = Number(this.dataset.getQuantity);
        const sets = Math.floor(prices.length / (paid + free));
        const freeCount = (this.dataset.repeat === 'true' ? sets : Math.min(1, sets)) * free;
        discounted = original - prices.sort((a, b) => a - b).slice(0, freeCount).reduce((sum, price) => sum + price, 0);
      }
      this.querySelector('[data-atelier-original]').textContent = this.formatPrice(original);
      this.querySelector('[data-atelier-total]').textContent = this.formatPrice(discounted);
    }
  });
})();
